import { render } from "./OurAchievements.vue?vue&type=template&id=5a913540&scoped=true"
import script from "./OurAchievements.vue?vue&type=script&lang=js"
export * from "./OurAchievements.vue?vue&type=script&lang=js"

import "./OurAchievements.vue?vue&type=style&index=0&id=5a913540&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a913540"]])

export default __exports__